"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = VideoPlaceholder;

var _react = _interopRequireDefault(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_placeholder.scss");

function VideoPlaceholder(_ref) {
  var text = _ref.text,
      icon = _ref.icon,
      iconColor = _ref.iconColor,
      subtitle = _ref.subtitle;
  return _react["default"].createElement("div", {
    className: "video-placeholder"
  }, _react["default"].createElement(_uiKit.Icon, {
    className: "video-placeholder__icon",
    name: icon,
    color: iconColor
  }), _react["default"].createElement("h1", null, text), subtitle ? _react["default"].createElement("p", null, subtitle) : null);
}

VideoPlaceholder.defaultProps = {
  text: "We're getting your video ready.",
  icon: "rushedit",
  iconColor: "monkey"
};